/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

export const columns: TableColumn[] = [
    {
        Header: 'tableCommon.sl_no',
        accessor: 'slno',
      },
      {
        Header: 'workflow.tableColumns.workflowName',
        accessor: 'name',
      },
      {
        Header: 'scheduleFrequency.tableColumns.activity_type_name',
        accessor: 'activity_name',
      },
      // {
      //   Header: 'Status',
      //   accessor: 'status',
      // },
      {
        Header: 'workflow.tableColumns.status',
        accessor: 'publish_status',
      },
]

interface TableColumn {
    Header: string;
    accessor: string;
  }